import Icon from "@ant-design/icons";
const BalconySvg = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.8418 12.5745V24V18.286H8.10871V24V20.3796H2.8418"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M22.3099 12.5745V24V18.286H17.043V24V20.3796H22.3099"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M10.6465 23.7557H12.5153H14.3866"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M12.563 9.6723L12.4922 24"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path
      d="M1 9.68455C4.86713 9.68455 8.71471 9.67722 12.5623 9.67233C16.4099 9.665 20.2575 9.66012 24.1246 9.66012C22.2631 4.51046 18.7355 1 12.1983 1C6.8923 1 2.46086 3.89973 1 9.68455Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path d="M7.74219 15.4987H17.3062" stroke="#31493C" strokeMiterlimit="10" />
  </svg>
);

const BalconyIcon = (props) => <Icon component={BalconySvg} {...props} />;

export default BalconyIcon;
